export const HIDDEN_ASSET:string[] = [
    'soETH',
    'BTC',
    'UST',
    'soFTT',
    'RAY-soETH'
]
